import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExitIcon } from "@100mslive/react-icons";
import {
  Avatar,
  Box,
  Dropdown,
  Flex,
  HorizontalDivider,
  Text,
} from "@100mslive/roomkit-react";
import { getImageURL } from "../../common/utils";
import request from "@services/request";

const AvatarDropdown = () => {
  const parseStoredUser = () => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const storedUser = parseStoredUser();
  const [user, setUser] = useState(storedUser || null);
  const { t } = useTranslation();

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await request.goMe();
        const payload = res?.data?.data || res?.data || res || null;
        if (mounted && payload) setUser(payload);
      } catch (e) {
        // ignore
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  const avatarSrc = user?.avatar ? getImageURL(user.avatar) : null;

  const urlToken = (() => {
    try {
      return new URLSearchParams(window.location.search).get("token");
    } catch (e) {
      return null;
    }
  })();

  const sessionToken = (() => {
    try {
      return sessionStorage.getItem("token");
    } catch (e) {
      return null;
    }
  })();

  const isLoggedIn = Boolean(
    user ||
      storedUser ||
      localStorage.getItem("token") ||
      sessionToken ||
      urlToken
  );
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("circle_id");
    localStorage.removeItem("meet_room_id");
    localStorage.removeItem("room_id");
    localStorage.removeItem("type");
    window.location.replace(`/sign-in`);
  };

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Box
          css={{
            cursor: "pointer",
            p: "$1",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "$round",
          }}
        >
          <Avatar
            src={avatarSrc}
            name={user?.name || t("lbl_anonymous")}
            css={{
              width: 36,
              height: 36,
              fontSize: "$sm",
              borderRadius: "50%",
              border: "1px solid $on_surface_low",
            }}
          />
        </Box>
      </Dropdown.Trigger>

      <Dropdown.Content
        sideOffset={8}
        align="end"
        css={{
          backgroundColor: "$surface_bright",
          minWidth: 340,
          r: "$4",
          p: "$9",
          boxShadow: "0 12px 32px rgba(0,0,0,0.14)",
        }}
      >
        <Flex direction="column" css={{ gap: "$2" }}>
          <Flex css={{ alignItems: "center", gap: "$3", paddingBottom: "$1" }}>
            <Box css={{ mr: "$3" }}>
              <Avatar
                src={avatarSrc}
                name={user?.name || t("lbl_anonymous")}
                css={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  border: "1px solid $on_surface_low",
                }}
              />
            </Box>
            <Box>
              <Text variant="h6">{user?.name || t("lbl_anonymous")}</Text>
              <Text css={{ color: "$on_surface_medium", mt: "$1" }}>
                {user?.email || ""}
              </Text>
            </Box>
          </Flex>

          <HorizontalDivider
            css={{
              mt: "$9",
              mb: "$3",
              height: 1,
              backgroundColor: "$on_surface_low",
              border: "none",
            }}
          />

          {isLoggedIn && (
            <Box>
              <Dropdown.Item asChild>
                <Box
                  as="button"
                  onClick={handleLogout}
                  css={{
                    width: "100%",
                    textAlign: "left",
                    p: "$3",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "$2",
                    display: "flex",
                    alignItems: "center",
                    gap: "$2",
                    transition: "background 120ms ease, transform 120ms ease",
                    "&:hover": {
                      backgroundColor: "$alert_error_dim",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <Box
                    css={{
                      color: "$alert_error_default",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ExitIcon />
                  </Box>
                  <Text
                    css={{ fontWeight: 600, color: "$alert_error_default" }}
                  >
                    {t("lbl_logout") || "Logout"}
                  </Text>
                </Box>
              </Dropdown.Item>
            </Box>
          )}
        </Flex>
      </Dropdown.Content>
    </Dropdown.Root>
  );
};

export default AvatarDropdown;
